export enum SubscriptionPaymentMethod {
    Stripe = 1,
    Email = 2
}

(SubscriptionPaymentMethod as any).__typeName = "SubscriptionPaymentMethod";
